import { Component, Input, OnInit, ViewEncapsulation, output, inject } from '@angular/core';
import { unionBy } from 'lodash';
import { Accordion, TabModule, AccordionV2Module } from '@schenck/rotec-components';
import { Observable, of, zip } from 'rxjs';
import { groupBy, mergeMap, shareReplay, switchMap, toArray } from 'rxjs/operators';
import {
  ReportTemplateConfiguration,
  ReportTemplateFieldDefinition,
} from 'src/dto/report-template';
import { ReportTemplateFieldCategory } from 'src/dto/report-template/report-template-field-category.enum';
import { ReportTemplateService } from 'src/services';
import { TemplateToolboxSettings } from 'src/utils/interfaces/export-settings.interface';
import { TemplateToolboxCategorySettingsComponent } from './template-toolbox-category-settings/template-toolbox-category-settings.component';
import { TemplateToolboxCategoryComponent } from './template-toolbox-category/template-toolbox-category.component';
import { TemplateToolboxCategoryFreetextComponent } from './template-toolbox-category-freetext/template-toolbox-category-freetext.component';
import { TemplateToolboxItemFilterPipe } from './template-toolbox-item-filter.pipe';

@Component({
  selector: 'rc-template-toolbox',
  templateUrl: './template-toolbox.component.html',
  styleUrls: ['./template-toolbox.component.less'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    TabModule,
    TemplateToolboxCategorySettingsComponent,
    AccordionV2Module,
    TemplateToolboxCategoryComponent,
    TemplateToolboxCategoryFreetextComponent,
    TemplateToolboxItemFilterPipe,
  ],
})
export class TemplateToolboxComponent implements OnInit {
  private readonly reportTemplateService = inject(ReportTemplateService);

  ReportTemplateFieldCategory = ReportTemplateFieldCategory;
  categorizedFieldDefinitions$: Observable<
    [ReportTemplateFieldCategory, ReportTemplateFieldDefinition[]]
  >;
  @Input() userDefinedFields: ReportTemplateFieldDefinition[];
  @Input() config: ReportTemplateConfiguration;
  readonly configChange = output<ReportTemplateConfiguration>();
  readonly settings = output<TemplateToolboxSettings>();

  public accordions: Accordion[] = [
    { id: 'logo', title: 'Logo' },
    { id: 'header', title: 'header' },
    { id: 'typeData', title: 'typeData' },
    { id: 'measurement', title: 'Measurement' },
    { id: 'freeTextfield', title: 'Free Text Field' },
  ];

  ngOnInit() {
    this.categorizedFieldDefinitions$ = this.reportTemplateService.getFieldDefinitions().pipe(
      // Only one request pls
      shareReplay(),
      // Overwrite field definitions with user-defined field definitions if they have the same name
      switchMap((fieldDefinitions) =>
        unionBy(this.userDefinedFields, fieldDefinitions, (f) => f.name)
      ),
      groupBy((fieldDefinition) => fieldDefinition.category),
      mergeMap((group) => zip(of(group.key), group.pipe(toArray())))
    );
  }

  public settingsChanged(settings: TemplateToolboxSettings): void {
    this.config.language = settings.language;
    this.config.numberOfDecimalPlaces = settings.decimals;
    this.config.lengthUnit = settings.lengthUnit;
    this.config.rotationUnit = settings.rotationUnit;
    this.config.measuringRun = settings.measuringRuns;
    this.config.unbalUnit = settings.unbalUnit;
    this.config.weightUnit = settings.weightUnit;
    this.config.isUnbalanceAsMass = settings.isUnbalanceAsMass;
    this.settings.emit(settings);
  }
}
